"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Skeleton = _interopRequireDefault(require("@eig-builder/core-ui/Skeleton"));

var _Divider = _interopRequireDefault(require("@eig-builder/core-ui/Divider"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  float: left;\n  margin-left: ", "px;\n  margin-top: ", "px !important;\n  margin-right: ", "px;\n  background-color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  width: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  padding-left: ", "px;\n  width: 100%;\n  background-color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Container = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.theme.spacing(3);
}, function (props) {
  return props.theme.palette.background["default"];
});

var HeaderDivider = (0, _styledComponents["default"])(_Divider["default"])(_templateObject2());
var Bar = (0, _styledComponents["default"])(_Skeleton["default"])(_templateObject3(), function (props) {
  return props.theme.spacing(3);
}, function (props) {
  return props.theme.spacing(4.5);
}, function (_ref) {
  var padding = _ref.padding;
  return padding;
}, function (props) {
  return props.theme.palette.white.main;
});

var generateBars = function generateBars(width, height, amount, randomSizing) {
  var result = [];

  for (var i = 0; i < amount; i++) {
    var padding = randomSizing ? Math.floor(Math.random() * 50) : 0;
    result.push( /*#__PURE__*/_react["default"].createElement(Bar, {
      key: i,
      width: width - padding,
      padding: padding,
      height: height
    }));
  }

  return result;
};

var TableLoadingPlaceholder = (0, _react.memo)(function (_ref2) {
  var height = _ref2.height;
  var amount = Math.floor((height - 20) / 26) * 4;
  var skeletons = generateBars(224, 26, amount, true);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Container, {
    height: 50
  }, generateBars(105, 20, 8)), /*#__PURE__*/_react["default"].createElement(HeaderDivider, null), /*#__PURE__*/_react["default"].createElement(Container, null, skeletons.map(function (renderBar, index) {
    if (index % 4 === 0) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: index
      }, /*#__PURE__*/_react["default"].createElement(HeaderDivider, null), renderBar);
    } else {
      return renderBar;
    }
  })));
});
TableLoadingPlaceholder.propTypes = {
  height: _propTypes["default"].number
};
var _default = TableLoadingPlaceholder;
exports["default"] = _default;